//import firebase from 'firebase'
import React from 'react'
import {connect} from "react-redux"
import {withRouter} from 'react-router'
import AreaPageContent from './AreaPageContent'
import { setTitle, fetchTherapyAreas, fetchTherapyCategories, fetchVideos } from "../../actions"
import { fetchParentPatientRecords } from '../../actions/parent'

@connect((store) => {
	return {
		User: store.User.User,
		therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
		videos: store.videos,
		patient_records: store.patient_records
	}
})
class AreaPage extends React.Component {
	constructor(props){
		super(props)

		this.area = this.area.bind(this);
		this.videoClick = this.videoClick.bind(this)
		this.videos = this.videos.bind(this)

	}

	componentDidMount(){
		const { dispatch, therapy_areas, params } = this.props;
		dispatch(fetchTherapyAreas());
		dispatch(fetchTherapyCategories());
		dispatch(fetchVideos());
		dispatch(setTitle(`${therapy_areas[params.id].name}`));
	}

	videos(){
		const {
				videos,
				therapy_areas,
				patient_records,
				User
			} = this.props;

			let owner = (User.owner && User.ownPractices.length > 0);
			let parent = User.parent ? User.parent : false;
			let therapist = User.therapist ? User.therapist : false;

			let allVideos = videos;

			let patientVideos = [];
			let patientRecords = {};

			if (owner || therapist){
				patientRecords = Object.values(allVideos).map(function (video) {
					patientVideos.push(video.id)
				});
			} else if(parent){
				patientRecords = Object.values(patient_records).map(function (videoId) {
					Object.keys(videoId.videosCount).forEach(function (v) {
						patientVideos.push(v)
					})
				})
			}

			var newpvideos = {}
			patientVideos.forEach(function (v) {
				newpvideos[v] = v
			})
			// return patientVideos
			// console.log('new video',newpvideos)
			return Object.values(videos).filter(v => patientVideos.indexOf(v._id) !== -1)
			// console.log('old video', videos)
	}


	videoClick(video){
		const { history } = this.props;
		history.push(`/page/videos/${video._id}`)
	}

	area(){
		const { params, therapy_areas } = this.props;
		return therapy_areas[params.id] || {}
	}

	render() {
		const { therapy_categories, videos } = this.props;
		return <AreaPageContent videos={this.videos()} videoClick={this.videoClick}  area={this.area()} therapy_categories={Object.values(therapy_categories)} />
	}
}

export default withRouter(AreaPage);



// WEBPACK FOOTER //
// ./src/components/home/AreaPage.jsx